// import { createTheme } from '@mui/material/styles';
// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#F36F21', // ICICI Prudential Orange C00026
//       // main: '#C00026', // ICICI Prudential Red like mobile app
//     },
//     secondary: {
//       main: '#00529B', // Complementary Blue
//     },
//     background: {
//       default: '#F7F9FC',
//     },
//   },
//   typography: {
//     fontFamily: 'Roboto, sans-serif',
//   },
// });
// export default theme;


// theme.js
import { createTheme } from '@mui/material/styles';
const theme = createTheme({
  palette: {
    primary: {
      main: '#C00026', // LIVA Red ff7528 
      light: '#FF5252',
      dark: '#8B0000',
    },
    secondary: {
      main: '#00529B', // LIVA Blue for headings
      light: '#4F83CC',
      dark: '#002F6C',
    },
    action: {
      active: '#FF9800', // Orange for buttons
      hover: '#F57C00',
    },
    background: {
      default: '#F7F9FC',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#333333',
      secondary: '#757575',
    },
  },
  typography: {
    fontFamily: 'Mulish, Roboto, sans-serif',
    h1: {
      fontFamily: 'Mulish-Bold, sans-serif',
    },
    h2: {
      fontFamily: 'Mulish-Bold, sans-serif',
    },
    h3: {
      fontFamily: 'Mulish-Bold, sans-serif',
    },
    h4: {
      fontFamily: 'Mulish-SemiBold, sans-serif',
    },
    h5: {
      fontFamily: 'Mulish-SemiBold, sans-serif',
    },
    h6: {
      fontFamily: 'Mulish-Medium, sans-serif',
    },
    body1: {
      fontFamily: 'Mulish-Regular, sans-serif',
    },
    body2: {
      fontFamily: 'Mulish-Regular, sans-serif',
    },
    button: {
      fontFamily: 'Mulish-Bold, sans-serif',
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 16px',
        },
        contained: {
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
          '&:hover': {
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        },
      },
    },
  },
});
export default theme;